import React from 'react';
import PropTypes from 'prop-types';
import QuestionCircleIcon from 'adp-react-icons/lib/fa/question-circle';
import {
  Button,
  Textbox,
  Radio,
  Popover,
  OverlayTrigger
} from 'adp-react-components';

function isValidCode(code) {
  return code != '';
}

class VerificationCode extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      verificationCode: '',
      deliveryMethodType: '',
      trainee: false,
      terms: '',
      resendLinkVisible:true
    };
  }
  componentDidMount() {
    fetch(context+'/enroll/adpPassword.faces?enrollAjaxForm', {
      method: 'POST',
      //same-origin is needed to keep the cookies
      credentials: 'same-origin',
      headers: {
        Accept:
          'text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,image/apng,*/*;q=0.8',
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body:
        'enrollAjaxForm=enrollAjaxForm&enrollAjaxForm:submitButton=&javax.faces.ViewState=' +
        Tier0.get('javax.faces.ViewState').value
    })
      .then(response => {
        return response.json();
      })
      .then(data => {
        if (data.success == 'false' || data.success == false) {
          if (data.wizard.message == 'true') {
            this.props.showSessionExpired();
            return;
          }
          this.props.showErrorMessage(data.wizard.message, 'error');
          return;
        }
        if (this.props.deliverypageexist && data.activation.traine) {
          this.setState({
            deliveryMethodType: this.props.deliveryMediumType,
            verificationCode: data.activation.code,
            trainee: data.activation.traine
          });
        } else if (!this.props.deliverypageexist && data.activation.traine) {
          this.setState({
            verificationCode: data.activation.code,
            deliveryMethodType: data.deliveryType.mailid,
            trainee: data.activation.traine
          });
        } else if (!this.props.deliverypageexist && !data.activation.traine) {
          this.setState({
            verificationCode: '',
            deliveryMethodType: data.deliveryType.mailid
          });
        } else {
          this.setState({
            verificationCode: '',
            deliveryMethodType: this.props.deliveryMediumType
          });
          this.setState({
            terms: data.misc.terms
          });
        }
      });
  }
  onVerificationCode(value) {
    this.setState({
      verificationCode: value
    });
    this.props.showErrorMessage('', 'error');
  }
  onResend(event) {
    gtag('event', 'Enroll|ActivationCode|ResendLink', {
      'event_category': 'Admin Login',
      'event_label': 'Activation Code'
    });
    this.props.showErrorMessage('', 'error');
    if (this.props.deliverypageexist) {
      this.props.showDeliveryMethod();
    } else {
      fetch(context+'/enroll/adpPassword.faces?enrollAjaxSendActivationForm=', {
        method: 'POST',
        //same-origin is needed to keep the cookies
        credentials: 'same-origin',

        headers: {
          Accept:
            'text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,image/apng,*/*;q=0.8',

          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body:
          'enrollAjaxSendActivationForm=enrollAjaxSendActivationForm&enrollAjaxSendActivationForm:submitButton=&javax.faces.ViewState=' +
          Tier0.get('javax.faces.ViewState').value
      })
        .then(response => {
          return response.json();
        })
        .then(data => {
          if (data.success == 'false' || data.success == false) {
            if (data.wizard.message == 'true') {
              this.props.showSessionExpired();
              return;
            }
            this.props.showErrorMessage(data.wizard.message, 'error');
            return;
          }
          if (!this.props.deliverypageexist && !data.activation.traine) {
            this.props.showErrorMessage(this.props.resendAcCodeMessage+' '+data.deliveryType.mailid, 'success');
          }
          if (this.props.deliverypageexist && data.activation.traine) {
            this.setState({
              deliveryMethodType: this.props.deliveryMediumType,
              verificationCode: data.activation.code,
              trainee: data.activation.traine
            });
          } else if (!this.props.deliverypageexist && data.activation.traine) {
            this.setState({
              verificationCode: data.activation.code,
              deliveryMethodType: data.deliveryType.mailid,
              trainee: data.activation.traine
            });
          } else if (!this.props.deliverypageexist && !data.activation.traine) {
            this.setState({
              verificationCode: '',
              deliveryMethodType: data.deliveryType.mailid
            });
          } else {
            this.setState({
              verificationCode: '',
              deliveryMethodType: this.props.deliveryMediumType
            });
            this.setState({
              terms: data.misc.terms
            });
          }
        });
    }

  }

  onSubmit(event) {
    gtag('event', 'Enroll|ActivationCode|Click', {
      'event_category': 'Admin Login',
      'event_label': 'Activation Code'
    });
    this.props.showErrorMessage('', 'error');
    fetch(context+'/enroll/adpPassword.faces?enrollActivationCodeForm=', {
      method: 'POST',
      //same-origin is needed to keep the cookies
      credentials: 'same-origin',

      headers: {
        Accept:
          'text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,image/apng,*/*;q=0.8',

        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body:
        'enrollActivationCodeForm=enrollActivationCodeForm&enrollActivationCodeForm:acCode=' +
        this.state.verificationCode +
        '&enrollActivationCodeForm:submitButton=&javax.faces.ViewState=' +
        Tier0.get('javax.faces.ViewState').value
    })
      .then(response => {
        return response.json();
      })
      .then(data => {
        if (data.success == 'false' || data.success == false) {
          if (data.wizard.message == 'true') {
            this.props.showSessionExpired();
            return;
          }
          var responseData = data.wizard.message;
          if(responseData.indexOf('UserLocked=Y') != -1){

            this.setState({
              resendLinkVisible: false
            });
              responseData = responseData.replace('UserLocked=Y','');
          }
          this.props.showErrorMessage(responseData, 'error');
        } else {
          this.props.showcreateSecurityQnA();
        }
      });
  }

  onHasErrorChange(value) {
    this.setState({
      hasError: value
    });
  }

  handleKeyPress(e) {
     if (e.charCode == 13) {
       e.preventDefault(); //preventing html5 default form submit
       this.onSubmit();
     }
   }

  render() {
    let isValid = isValidCode(this.state.verificationCode);
    var messageList = this.props.verificationCodeHelpMessage.map(function(
      message
    ) {
      return (
        <li key={message} value={message}>
          {message}
        </li>
      );
    });
    const popover = (
      <Popover
        id="popover-1"
        placement="bottom"
        title=""
        className="vdl-custom-popover-content">
        <ul className="verification-code-helper-content">{messageList}</ul>
      </Popover>
    );
    return (
      <div className="vdl-row login-form">
        <div className="vdl-col-md-12">
          <form className="adp-form fyp">
            <div className="form-group password">
              <div className="form-group">
                <Radio
                  value={this.state.deliveryMethodType}
                  disabled={true}
                  radioGroupValue={this.state.deliveryMethodType}
                  className="vdl-radio__toggle-custom-readonly-text">
                  {this.state.deliveryMethodType}
                </Radio>
              </div>
              <div className="vdl-row">
                <div className="vdl-col-sm-6 vdl-col-xs-12">
                  <label htmlFor="user_id">
                    {this.props.verificationcodeLabel}
                  </label>
                  <span className="verification-code-helper">
                    <OverlayTrigger
                      trigger="click"
                      placement="top"
                      overlay={popover}>
                      <QuestionCircleIcon />
                    </OverlayTrigger>
                  </span>
                </div>
                {/* vdl-col-sm-6 vdl-col-xs-12 */}

                {/* vdl-col-sm-6 hidden-xs vdl-text-xs-right vdl-hidden-sm-down */}
              </div>
              {/* vdl-row */}
              <div className="form-group password">
                <div className="input-group-full">
                  <Textbox
                    autoFocus
                    value={this.state.verificationCode}
                    type="text"
                    onKeyPress={this.handleKeyPress.bind(this)}
                    onChange={this.onVerificationCode.bind(this)}

                  />
                </div>
              </div>
              {/* input-group-full */}
            </div>
            {/* form-group  */}

            {/* form-group password */}
            <div className="form-group submit vdl-text-xs-center">
              <Button
                className="primary"
                disabled={!isValid}
                onClick={this.onSubmit.bind(this)}>
                {this.props.submitcodeLabel}
              </Button>
            </div>
            {/* form-group submit vdl-text-xs-center */}
          </form>
          <h5 className="vdl-text-xs-center forgot-password">
          {
                    this.state.resendLinkVisible
                      ? <a href="#" onClick={this.onResend.bind(this)}>
                        {this.props.resendcodelink}{' '}
                      </a>
                      : null
                  }
          </h5>


          {/* adp-form */}
        </div>
        {/* vdl-col-md-12 */}
      </div>
    );
  }
}
VerificationCode.propTypes = {
  verificationCode: PropTypes.string,
  submit: PropTypes.string
};

VerificationCode.getDefaultProps = {
  verificationCode: undefined,
  submit: undefined
};

export default VerificationCode;



// WEBPACK FOOTER //
// ./src/scenes/admin-login/enroll/verification-code.js